import { render, staticRenderFns } from "./infoSideMenu.vue?vue&type=template&id=6b1edc60&"
import script from "./infoSideMenu.vue?vue&type=script&lang=js&"
export * from "./infoSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./infoSideMenu.vue?vue&type=style&index=0&id=6b1edc60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardTitle,VDivider})
